<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
        <h2>Being lazy like us cats can be your superpower</h2>
        <p class="riskyPaws-copy">
          🌟 "In the cozy world of RiskyPaws, our feline friends teach us that there's an art to being 'lazy.' It’s not about doing nothing; it’s about conserving energy and being active only when it truly matters. 🐾🛌

In the realm of investments, we take a leaf out of our cats’ books to embrace the concept of 'Lazy Portfolios.' Just like a cat who lounges in the sun, only leaping into action for the right opportunity, these portfolios are about smart, low-effort investing that avoids the unnecessary hustle of active trading. 🌞📈

Lazy Portfolios are the purr-fect antidote to the myth that constant activity leads to greater returns. History whispers to us, much like a wise old cat, that active investing often doesn’t outperform the market in the long run. Instead, these portfolios, carefully balanced and diversified, are like a cat napping in a sunbeam, undisturbed by the daily commotion, growing steadily over time. 📊💤

So, get ready to explore various Lazy Portfolios with RiskyPaws! Each one is crafted to offer a different blend of investments, much like how every cat has its unique favorite napping spot. We'll guide you through these options, helping you choose the portfolio that resonates with your financial personality and goals. 🐱💰

Remember, in the world of finance, sometimes the wisest move is to stretch, yawn, and let your investments grow at their own natural pace. Let's learn from our feline gurus - there's power in peaceful, patient, and 'lazy' growth!" 🌱🐈
  </p>
  
        <h3>Bill Bernstein's Lazy Portfolios </h3>
        <p>We take inspiration from the quiet wisdom of Bill Bernstein's Lazy Portfolios. It’s like observing the calm, yet calculated approach of a seasoned feline, gracefully navigating the financial landscape with a blend of patience and insight. Explore the Coward and No Brainer portfolios here and embrace the art of purr-fectly balanced investing!" 🐾</p>
  <div class="tradingview-widget-container">
    <div class="tradingview-widget-container__widget"></div></div></div>   <div></div></div>
      
    </div><br>
    
  <br><br><br><br><br><br>
</template>

<script setup>
import { onMounted } from 'vue';


onMounted(() => {
  const script = document.createElement('script');
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
  script.async = true;
  script.innerHTML = JSON.stringify({
    "colorTheme": "light",
    "dateRange": "12M",
    "showChart": true,
    "locale": "en",
    "largeChartUrl": "https://www.riskypaws.com/lazyportfolio",
    "isTransparent": false,
    "showSymbolLogo": true,
    "showFloatingTooltip": false,
    "width": "350",
    "height": "700",
    "plotLineColorGrowing": "rgba(53, 28, 117, 1)",
    "plotLineColorFalling": "rgba(53, 28, 117, 1)",
    "gridLineColor": "rgba(217, 210, 233, 0)",
    "scaleFontColor": "rgba(0, 0, 0, 1)",
    "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
    "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
    "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
    "belowLineFillColorFallingBottom": "rgba(180, 167, 214, 0)",
    "symbolActiveColor": "rgba(142, 124, 195, 0.12)",
    "tabs": [
      {
        "title": "Coward Portfolio",
        "symbols": [
          { "s": "AMEX:VV", "d": "Vanguard Large Cap" },
          { "s": "AMEX:IJS", "d": "iShares S&P Small-Cap 600 Value" },
          {
          "s": "AMEX:VTV",
          "d": "Vanguard Value"
        },
        {
          "s": "AMEX:IJR",
          "d": "iShares MSCI Emerging Markets"
        },
        {
          "s": "AMEX:VGK",
          "d": "Vanguard FTSE Europe"
        },
        {
          "s": "AMEX:VPL",
          "d": "Vanguard FTSE Pacific"
        },
        {
          "s": "AMEX:VNQ",
          "d": "Vanguard Real Estate"
        },
        {
          "s": "NASDAQ:SHY",
          "d": "\tiShares 1-3 Year Treasury Bond"
        }
      ]
    },
    {

        "title": "No Brainer Portfolio",
        "symbols": [
          { "s": "NASDAQ:BND", "d": "Vanguard Total Bond Market ETF" },
          { "s": "AMEX:VEA", "d": "Vanguard FTSE Developed Markets ETF" },
          { "s": "AMEX:VB", "d": "Vanguard Small-Cap ETF" },
          { "s": "AMEX:VOO", "d": "Vanguard S&P 500 ETF" }
        ]
      }
    ]
  });
  document.querySelector('.tradingview-widget-container__widget').appendChild(script);
});
</script>

<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>